__turbopack_context__.v({
  "active": "kr8dhG_active",
  "add-to-cart-button": "kr8dhG_add-to-cart-button",
  "arrows": "kr8dhG_arrows",
  "buttonsContainer": "kr8dhG_buttonsContainer",
  "cardQtySelector": "kr8dhG_cardQtySelector",
  "cart-btn-close": "kr8dhG_cart-btn-close",
  "infoContainer": "kr8dhG_infoContainer",
  "leftArrowSlickSuggSet": "kr8dhG_leftArrowSlickSuggSet",
  "llevarSetButton": "kr8dhG_llevarSetButton",
  "llevarSetButtonModal": "kr8dhG_llevarSetButtonModal",
  "llevarSetContainer": "kr8dhG_llevarSetContainer",
  "pdp-qty": "kr8dhG_pdp-qty",
  "pdpPrice": "kr8dhG_pdpPrice",
  "pdpProductPrice": "kr8dhG_pdpProductPrice",
  "pricePerUnitCont": "kr8dhG_pricePerUnitCont",
  "product-name": "kr8dhG_product-name",
  "productButton": "kr8dhG_productButton",
  "productCard": "kr8dhG_productCard",
  "productCardSlider": "kr8dhG_productCardSlider",
  "productCheckbox": "kr8dhG_productCheckbox",
  "productDetail": "kr8dhG_productDetail",
  "productDetailWrapper": "kr8dhG_productDetailWrapper",
  "productImage": "kr8dhG_productImage",
  "productImageWrapper": "kr8dhG_productImageWrapper",
  "productList": "kr8dhG_productList",
  "productName": "kr8dhG_productName",
  "productPrice": "kr8dhG_productPrice",
  "productTopInfo": "kr8dhG_productTopInfo",
  "qtySelector": "kr8dhG_qtySelector",
  "qtyTitle": "kr8dhG_qtyTitle",
  "rightArrowSlickSuggSet": "kr8dhG_rightArrowSlickSuggSet",
  "scrollableContent": "kr8dhG_scrollableContent",
  "select-variant": "kr8dhG_select-variant",
  "separator": "kr8dhG_separator",
  "setContainer": "kr8dhG_setContainer",
  "setListItemImage": "kr8dhG_setListItemImage",
  "setListItemImageWrapper": "kr8dhG_setListItemImageWrapper",
  "setListItemInfo": "kr8dhG_setListItemInfo",
  "setListItemName": "kr8dhG_setListItemName",
  "setListItemPpum": "kr8dhG_setListItemPpum",
  "setListItemPrice": "kr8dhG_setListItemPrice",
  "setListItemRow": "kr8dhG_setListItemRow",
  "setListModal": "kr8dhG_setListModal",
  "setListModalClose": "kr8dhG_setListModalClose",
  "setListModalContent": "kr8dhG_setListModalContent",
  "setListModalHeader": "kr8dhG_setListModalHeader",
  "setListModalScroll": "kr8dhG_setListModalScroll",
  "setListModalTitle": "kr8dhG_setListModalTitle",
  "setListModalTitleSpacer": "kr8dhG_setListModalTitleSpacer",
  "shortDescription": "kr8dhG_shortDescription",
  "sidebarImageSlider": "kr8dhG_sidebarImageSlider",
  "sku": "kr8dhG_sku",
  "suggestedSetWrapper": "kr8dhG_suggestedSetWrapper",
  "title": "kr8dhG_title",
});
